import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Suppress known infrastructure errors from console to reduce noise.
// These are non-fatal backend configuration issues (Identity Pool or endpoint permissions)
// that don't impact core app functionality.
const originalError = console.error;
const originalWarn = console.warn;

const isKnownInfrastructureError = (args) => {
  const message = String(args?.[0] || '').toLowerCase();
  return (
    message.includes('cognito-identity') ||
    message.includes('session-event') ||
    message.includes('preflight') ||
    message.includes('access control') ||
    message.includes('cors')
  );
};

console.error = function(...args) {
  if (!isKnownInfrastructureError(args)) {
    originalError.apply(console, args);
  }
};

console.warn = function(...args) {
  if (!isKnownInfrastructureError(args)) {
    originalWarn.apply(console, args);
  }
};

// Suppress unhandled promise rejections from known infrastructure issues
window.addEventListener('unhandledrejection', (event) => {
  const message = String(event.reason?.message || event.reason || '').toLowerCase();
  const isKnown = 
    message.includes('cognito-identity') ||
    message.includes('session-event') ||
    message.includes('preflight') ||
    message.includes('access control') ||
    message.includes('cors') ||
    message.includes('400') ||
    message.includes('403');
  
  if (isKnown) {
    // Suppress the unhandled rejection error
    event.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
